<template>
    <div
        style="position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;background:rgba(17,24,39,.55);padding:24px;"
        @click.self="$emit('close')"
    >
        <div style="background:#fff;border-radius:10px;box-shadow:0 20px 60px rgba(0,0,0,.3);width:100%;max-width:1280px;max-height:85vh;display:flex;flex-direction:column;overflow:hidden;">
            <!-- Header -->
            <div class="flex items-center justify-between px-6 py-3 border-b border-gray-200">
                <h3 class="m-0 text-sm font-semibold text-gray-700">Afbeelding kiezen uit mediabibliotheek</h3>
                <button type="button" class="text-gray-400 hover:text-gray-600" @click="$emit('close')">
                    <i class="far fa-times text-lg"></i>
                </button>
            </div>

            <!-- Browser + info sidebar (MediaLibrary owns the grid, the info panel
                 and the "Gebruiken" button in picker mode). -->
            <div class="flex-1 px-8 overflow-auto" style="min-height:0;">
                <media-library
                    :picker="true"
                    :initial-type="initialType"
                    :items-url="itemsUrl"
                    :stats-url="statsUrl"
                    :upload-url="uploadUrl"
                    :delete-url="deleteUrl"
                    :detail-url="detailUrl"
                    @select="$emit('select', $event)"
                ></media-library>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MediaPickerModal',

    props: {
        itemsUrl: { type: String, required: true },
        statsUrl: { type: String, required: true },
        uploadUrl: { type: String, required: true },
        deleteUrl: { type: String, required: true },
        detailUrl: { type: String, required: true },
        initialType: { type: String, default: '' },
    },

    mounted() {
        this._onKey = (e) => { if (e.key === 'Escape') this.$emit('close'); };
        document.addEventListener('keydown', this._onKey);
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this._onKey);
    },
};
</script>

<!-- Global (non-scoped): keep toasts above the picker modal (z-index 100000). -->
<style>
.toasted-container {
    z-index: 200000 !important;
}
</style>
